import React from 'react';
import { Route } from 'react-router-dom';
import AcademicYears from '../pages/academicYears/AcademicYears';
import AcademicYearsArchive from '../pages/academicYears/AcademicYearsArchive';
import CreateAcademicYear from '../pages/academicYears/CreateAcademicYear';
import EditAcademicYear from '../pages/academicYears/EditAcademicYear';
import PermissionGuard from '../components/global/PermissionGuard';

const academicYearsRoutes = (
    <>
        <Route
            path="/academic-years"
            element={
                <PermissionGuard permission="academic_years_list">
                    <AcademicYears />
                </PermissionGuard>
            }
        />

        <Route
            path="/academic-years/archive"
            element={
                <PermissionGuard permission="academic_years_archive_list">
                    <AcademicYearsArchive />
                </PermissionGuard>
            }
        />

        <Route
            path="/academic-years/create"
            element={
                <PermissionGuard permission="academic_years_create">
                    <CreateAcademicYear />
                </PermissionGuard>
            }
        />

        <Route
            path="/academic-years/:id/edit"
            element={
                <PermissionGuard permission="academic_years_edit">
                    <EditAcademicYear />
                </PermissionGuard>
            }
        />
    </>
);

export default academicYearsRoutes;
